<template>
  <div class="help-component">
    Having issues?
    <a href="https://wovenhelp.freshdesk.com/support/tickets/new">Get Help</a>
  </div>
</template>
<script>
export default {
  name: "Help",
};
</script>
<style lang="scss" scoped>
a {
  text-decoration-color: #000;
  color: #000;
}
.help-component {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: right;
  color: #616e7c;
  position: absolute;
  top: 64px;
  right: 64px;
}
</style>